module.exports = __webpack_public_path__ + "img/appleStoreBg.6253fc1e.png";